import AmendButtonLink from '@acorn-portal/shared/src/components/buttons/AmendButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Fade, Typography } from '@mui/material';
import React from 'react';
import { RoutePath } from '../../utils/Routes';

interface ISummaryCard {
	children: React.ReactNode;
	title?: string;
	isUpdated?: boolean;
	showAmendButton?: boolean;
	amendLink?: RoutePath;
}

const SummaryCard = ({ children, title, isUpdated = false, showAmendButton = true, amendLink }: ISummaryCard) => {
	return (
		<Fade in>
			<Box
				sx={{
					position: 'relative',
					border: isUpdated ? 3 : 1,
					borderColor: isUpdated ? '#4BB543' : 'grey.300',
					mb: 2,
					p: 4,
					pb: { sm: 7 },
					borderRadius: 2,
					width: { xs: '100%', sm: 'auto' },
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					alignItems: { xs: 'start', sm: 'center' },
					gap: 2,
				}}
			>
				{isUpdated && (
					<CheckCircleIcon
						sx={{
							color: 'green',
							position: 'absolute',
							top: 16,
							right: 16,
							zIndex: 1,
							fontSize: 24,
						}}
					/>
				)}

				<Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' } }}>
					{title && (
						<Typography
							sx={{
								display: { xs: 'none', sm: 'block' },
								fontSize: 18,
								fontWeight: 'bold',
								color: 'secondary.main',
								mb: 2,
							}}
						>
							{title}
						</Typography>
					)}
					{children}
					{showAmendButton && amendLink && (
						<Box sx={{ display: { xs: 'block', sm: 'none' }, mt: 2 }}>
							<AmendButtonLink text={`Amend ${title}`} to={amendLink} />
						</Box>
					)}
				</Box>

				{showAmendButton && amendLink && (
					<Box
						sx={{
							display: { xs: 'none', sm: 'flex' },
							position: 'absolute',
							bottom: 32,
							right: 26,
							minWidth: 100,
							alignItems: 'center',
						}}
					>
						<AmendButtonLink text='Amend' to={amendLink} />
					</Box>
				)}
			</Box>
		</Fade>
	);
};

export default SummaryCard;
